export default "__VITE_ASSET__CFCUf5R7__"